import {
	Fragment,
	ReactElement,
	useMemo
} from "react";
import { ActionAndOthers } from "client_legacy/ndaw/actions";
import { ActionList } from "../ActionList/ActionList";
import { actionComponentFactory, computeActionsToRender } from "../ActionList/actionsRenderHelpers";
import { FloatingActionMenu } from "./FloatingActionMenu";
import { ActionListBox } from "../ActionListBox/ActionListBox";
import { generateTrackingId } from "client/Misc/utils";

export type FloatingActionListMenuProps<TContext> = {
	actions: readonly ActionAndOthers<TContext>[];
	actionContext: TContext;
	menuTitle: string;
	visibleOn?: "responsive" | "always";
	trackingId: string;
};

export const FloatingActionListMenu = <TContext,>(props: FloatingActionListMenuProps<TContext>): ReactElement | null => {
	const {
		actions,
		actionContext,
		menuTitle,
		visibleOn = "responsive",
		trackingId
	} = props;

	const actionsToRender = useMemo(
		(): ActionAndOthers<TContext>[] => {

			return computeActionsToRender(
				actions,
				actionContext
			);
		},
		[actionContext, actions]
	);

	if (actionsToRender.length === 0) {
		return null;
	}

	return (
		<FloatingActionMenu
			trackingId={trackingId}
			visibleOn={visibleOn}
		>
			<ActionListBox
				menuTitle={menuTitle}
				trackingId={generateTrackingId(trackingId, "__dropover")}
			>
				<ActionList width="fill">
					{actionsToRender.map((x) => (
						<Fragment key={x.name}>
							{actionComponentFactory(x, actionContext)}
						</Fragment>
					))}
				</ActionList>
			</ActionListBox>
		</FloatingActionMenu>
	);
};
FloatingActionListMenu.displayNAme = "FloatingActionListMenu";
